import { RrsCategory } from "server/models"
import { TableGroupedIds, TableNestedIds } from "client/components"

export const GroupCategoriesByParent = (categories: RrsCategory[]) => {
    const groupedByParent: { [parentCategoryId: number]: RrsCategory[] } = { 0: [] }
    categories.forEach((category) => {
        if (category.categoryId === null) groupedByParent[0].push(category)
        else {
            if (!groupedByParent[category.categoryId]) groupedByParent[category.categoryId] = []
            groupedByParent[category.categoryId].push(category)
        }
    })
    return groupedByParent
}

export const GetCategoriesNested = (parentId: number, groupedByParent: { [parentCategoryId: number]: RrsCategory[] }) => {
    const nestedIds: TableNestedIds[] = []
    const childCategories = groupedByParent[parentId]
    if (childCategories) {
        childCategories.forEach((category) => {
            const nestedId: TableNestedIds = {
                id: category.id,
                nestedIds: GetCategoriesNested(category.id, groupedByParent),
            }
            nestedIds.push(nestedId)
        })

        // eslint-disable-next-line no-param-reassign
        delete groupedByParent[parentId] // remove used rows
    }
    return nestedIds
}

export const PrepareRrsCategoryNestedIds = (categories: RrsCategory[]) => {
    const groupedByParent = GroupCategoriesByParent(categories)
    const nestedIds: TableNestedIds[] = []

    Object.keys(groupedByParent).forEach((key) => {
        const parentCategoryId = key as unknown as number
        // continue if row was added to nested level
        if (!groupedByParent[parentCategoryId]) return

        // all filtered categories that were not added to nested levels will be added to the top level
        groupedByParent[parentCategoryId].forEach((category) => {
            const nestedId: TableNestedIds = {
                id: category.id,
                nestedIds: GetCategoriesNested(category.id, groupedByParent),
            }
            nestedIds.push(nestedId)
        })
    })

    const grouped: TableGroupedIds[] = nestedIds.length
        ? [{
            groupId: null,
            nestedIds,
            nestedGroupedIds: [],
        }]
        : []
    return grouped
}
